import _get from "lodash/get";
import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { cssHelpers } from '~helpers';
import formTheme from '../../styles/formTheme';
var TextAreaContainer = styled.div.withConfig({
  displayName: "TextAreaContainer",
  componentId: "sc-1l6n7fa-0"
})(["", " background-color:", ";border-top-left-radius:", ";border-top-right-radius:", ";position:relative;transition:background 0.3s ease-in 0.1s;", " ", " ", ""], cssHelpers.clearfix, function (_ref) {
  var skin = _ref.skin,
      theme = _ref.theme;
  return _get(theme, "form.input." + skin + ".backgroundColor", formTheme.form.input[skin].backgroundColor);
}, function (_ref2) {
  var theme = _ref2.theme;
  return rem(_get(theme, 'form.input.borderRadius', formTheme.form.input.borderRadius));
}, function (_ref3) {
  var theme = _ref3.theme;
  return rem(_get(theme, 'form.input.borderRadius', formTheme.form.input.borderRadius));
}, function (_ref4) {
  var focused = _ref4.focused,
      disabled = _ref4.disabled,
      skin = _ref4.skin,
      theme = _ref4.theme;
  return (focused || disabled) && css(["background-color:", ";"], _get(theme, "form.input." + skin + ".backgroundColorFocus", formTheme.form.input[skin].backgroundColorFocus));
}, function (props) {
  return !props.readOnly && css(["&:focus{background-color:", ";}"], _get(props, "theme.form.input[" + props.skin + "].backgroundColorFocus", formTheme.form.input[props.skin].backgroundColorFocus));
}, function (props) {
  return props.disabledValue && css(["background-color:transparent;cursor:not-allowed;"]);
});
export default TextAreaContainer;